<div class="p-4">
  <app-breadcrumbs [breadcrumbs]="breadcrumbList"></app-breadcrumbs>

  <div class="mb-4 mt-3 d-flex align-items-center justify-content-between">
    <div>
      <div class="text-xxl fw-600">
        Top Members of {{ orgDetail?.organizationName }}
      </div>
      <div class="text-sm text-blue-gray mt-2">
        Recognizing members ranked by their contributions, impact, and
        engagement within the organization.
      </div>
    </div>

    <div class="rank-box d-flex flex-column align-items-center">
      <div class="text-llg fw-700"># {{ orgDetail?.rank }}</div>
      <div class="text-s">Rank</div>
    </div>
  </div>

  <div>
    <app-header-filter
      [headerFilter]="headerFilterData"
      [isFilterApplied]="isFilterApplied"
      [isShowExportbtn]="tableData && tableData?.length > 0"
      [showSort]="false"
      (onShowFilters)="openFilters()"
      (onSearchByText)="searchByText($event)"
      (exportExcel)="exportAsExcel()"
    ></app-header-filter>
  </div>

  <div>
    <table-component
      [tableData]="tableData"
      [columnList]="tableHeaders"
      [isDragDisabled]="true"
      [isLoading]="false"
    ></table-component>

    <div>
      <mat-paginator
        [length]="total"
        [pageSize]="size"
        [pageIndex]="page"
        [pageSizeOptions]="[5, 10, 20]"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
